module.exports = __webpack_public_path__ + "static/media/ford-start.3123c8c9.png";